// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import { spacing } from 'presentations/views/styles';
import { gray04, primary } from 'presentations/views/styles/color';
import DashboardEventListItem from 'presentations/views/components/molecules/DashboardEventListItem';

import { keyForMergedEventListItem } from 'presentations/views/helpers/event';

import { useDashboardEventList, ViewModel } from './hooks';
import { ViewerItem } from 'presentations/api/schema/user';
import { DateTime } from 'infras/datetime';
import { ProjectEventListItem } from 'presentations/api/schema/project/project_event';

export interface Props {
  isLoading?: boolean;
  viewer: ViewerItem;
  date: DateTime;
  today: DateTime;
  isToday: boolean;
  isFuture: boolean;
  setIsEventIntegrating?: Function;
  currentUserId: string;
  timeZone: string;
  events: ProjectEventListItem[];
  startedAt: number;
  endedAt: number;
  isEventLoading: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const viewer = props.viewer;

  const { state, actions } = useDashboardEventList({
    viewer: props.viewer,
    date: props.date,
    today: props.today,
    isToday: props.isToday,
    isFuture: props.isFuture,
    setIsEventIntegrating: props.setIsEventIntegrating,
    timeZone: props.timeZone,
    events: props.events,
    startedAt: props.startedAt,
    endedAt: props.endedAt,
  });
  const isLoading = props.isLoading || props.isEventLoading;

  const renderViewModel = (viewModel: ViewModel, done: boolean) => {
    return (
      <DashboardEventListItem
        isAllDay={viewModel.isAllDay}
        startedAtString={viewModel.startedAtString}
        endedAtString={viewModel.endedAtString}
        mergedEvent={viewModel.event}
        key={keyForMergedEventListItem(viewModel.event)}
        accountCalendars={state.accountCalendars}
        isDone={done}
        onClick={() => actions.onClickEvent(viewModel)}
        project={viewModel.project}
        isViewerEvent={props.currentUserId === viewer.uid}
      />
    );
  };

  return (
    <>
      {!isLoading && state.eventModels.count === 0 && (
        <NoItems>{t('No Schedule')}</NoItems>
      )}
      {state.eventModels.alldayModels.length > 0 && (
        <AlldayContainer>
          {state.eventModels.alldayModels.map((m) =>
            renderViewModel(m, !props.isToday && !props.isFuture),
          )}
        </AlldayContainer>
      )}
      {state.eventModels.doneModels.map((m) => renderViewModel(m, true))}
      {state.eventModels.count > 0 && props.isToday && (
        <CurrentTime ref={state.currentRef}>
          <CurrentTimeHr />
        </CurrentTime>
      )}
      {state.eventModels.willModels.map((m) => renderViewModel(m, false))}
      {isLoading && (
        <>
          <DashboardEventListItem isLoading isViewerEvent={false} />
          <DashboardEventListItem isLoading isViewerEvent={false} />
          <DashboardEventListItem isLoading isViewerEvent={false} />
        </>
      )}
    </>
  );
}

const AlldayContainer = styled.div`
  padding-bottom: ${spacing(16)};
  border-bottom: 2px dashed ${gray04};
  margin-bottom: ${spacing(16)};
`;
const CurrentTime = styled.div`
  position: relative;
  height: 8px;
  margin-bottom: 16px;

  :before {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: ${primary};
  }
`;
const CurrentTimeHr = styled.hr`
  position: absolute;
  top: 3px;
  width: 100%;
  margin: 0;
  height: 2px;
  border-top: 2px solid ${primary};
`;
const NoItems = styled.div``;
